import { useGateContext } from '../gates.state'
import { gates, GateName } from '../registry'
import { resolveGate } from '../resolveGate'
import type { GateFn } from '../gates.types'

export function useGate(gateOrName: GateName | GateFn): boolean {
  const ctx = useGateContext()

  if (typeof gateOrName === 'function') {
    return gateOrName(ctx)
  }

  return resolveGate(gates[gateOrName], ctx)
}
